import * as React from 'react';
import { StatusPage, StatusCard, StatusGroup } from '@ixicare/ui';
import { t } from '~/i18n';
import connect from '~/store/connect';
import { State } from '~/store/types';
import { AlertPriority } from '@ixicare/resources';
import { useLowBatteryDevices } from './utils';

interface AlertStatusContainerProps {
  groupedAlerts: State['alerts']['groupedAlerts'];
}

const AlertStatusContainer: React.FC<AlertStatusContainerProps> = ({ groupedAlerts }) => {
  const lowBatteryDevices = useLowBatteryDevices();

  // AlertActivity component already does a fetch of 7 days.
  // React.useEffect(() => {
  //   fetchLatestAlerts(3);
  // }, []);

  return (
    <StatusPage title={t('alerts.status.header.title')} description={t('alerts.status.header.description')}>
      <StatusGroup title={t('alerts.status.residents')} seeAll={t('alerts.status.seeAll')} seeAllLink="/alerts">
        <StatusCard
          priority={AlertPriority.Critical}
          number={groupedAlerts[AlertPriority.Critical].open}
          title={t('alert.priority.critical')}
          link="/alerts"
        />
        <StatusCard
          priority={AlertPriority.Urgent}
          number={groupedAlerts[AlertPriority.Urgent].open}
          title={t('alert.priority.urgent')}
          link="/alerts"
        />
        <StatusCard
          priority={AlertPriority.Manual}
          number={groupedAlerts[AlertPriority.Manual].open}
          title={t('alert.priority.manual')}
          link="/alerts"
        />
        <StatusCard
          priority={AlertPriority.Informative}
          number={groupedAlerts[AlertPriority.Informative].open}
          title={t('alert.priority.informative')}
          link="/alerts"
        />
      </StatusGroup>
      <StatusGroup title={t('alerts.status.devices')} seeAll={t('alerts.status.seeAll')} seeAllLink="/alerts">
        <StatusCard
          priority={AlertPriority.DeviceCritical}
          number={groupedAlerts[AlertPriority.DeviceCritical].open}
          title={t('alert.priority.device_critical')}
          link="/alerts"
        />
        <StatusCard
          priority={AlertPriority.DeviceNonCritical}
          number={lowBatteryDevices?.length ?? 0}
          title={t('alert.priority.device_non_critical')}
          link="/alerts"
        />
      </StatusGroup>
    </StatusPage>
  );
};
export default connect((state: State) => ({
  groupedAlerts: state.alerts.groupedAlerts,
}))(AlertStatusContainer);
